module.exports = __webpack_public_path__ + "assets/media/favicon120.79ec9f2c3fffadb5876956e4d9d9a60c.png";